/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { redirect, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import OpportunityForm from "../../components/OpportunityForm";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";

function JobApplyPage() {
  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  useEffect(()=>{
    if(localStorage.getItem('token')===null || localStorage.getItem('token')===undefined){
        navigate('/login');
      }
      
  },[])

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="docAccessibility"/>
        <div className="doc-container" role="main" tabIndex={-1}>
          <h1 className="display-title center" ref={mainRef} tabIndex={-1}>{"Applied to job successfully"}</h1>
          <strong className="display-sub-title center" ref={mainRef} tabIndex={-1}>{"Thanks, we will let our corporate partner know. However, you should still submit an application on the job website."}</strong>
          <div className="component-container center uploading">
          <img src="/doc-access.svg" alt="Illustration of document access" className="instruction-img"/>
            <button className="center upload-button" onClick={()=>navigate('/jobs')}>Ok, Got it</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobApplyPage;
